import React from 'react';
import _ from 'lodash';
import {
    // Popover,
    // PopoverHeader,
    // PopoverBody,
    ListGroup,
    ListGroupItem,
    Card,
    CardHeader,
    CardBody,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
} from 'reactstrap';

const OfferInfo = ({
    flatOfferDiscountInfo,
    buyGetOfferDiscountInfo,
    buyGetRecurringDiscountInfo,
    offerLoading,
    cardWidth = '350px',
    cardHeight = '400px',
    productListHeight = '200px',
    popoverWidth = '100%',
    flatHeaderBgColor = '#2f3349',
    buyGetHeaderBgColor = '#28a745',
    isFlatOfferProductInCart = false,
    isBuyGetOfferProductInCart = false,
    isBuyGetRecurringProductInCart = false,
    popoverOpen,
    setPopoverOpen,
}) => {
    // Common styles object
    const styles = {
        cardContainer: {
            maxHeight: cardHeight,
            overflowY: 'auto',
            width: cardWidth,
            padding: '10px',
        },
        productList: {
            maxHeight: productListHeight,
            overflowY: 'auto',
        },
        productItem: {
            fontWeight: '500',
            padding: '12px 15px',
            fontSize: '14px',
            margin: '0',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        },
        cardStyle: {
            marginBottom: '15px',
        },
        cardHeaderStyle: {
            color: 'white',
            padding: '0 0',
            fontSize: '16px',
            fontWeight: 'bold',
        },
        cardTitle: {
            padding: '12px 15px',
            fontSize: '14px',
            margin: '0',
            backgroundColor: '#7367f0',
            width: '100%',
            borderTopLeftRadius: '10px',
            borderTopRightRadius: '10px',
        },
        noProductTitle: {
            padding: '12px 15px',
            fontSize: '14px',
            margin: '0',
            backgroundColor: '#7367f0',
            width: '100%',
        },
        cardBodyStyle: {
            color: 'white',
            padding: '0 0',
            fontSize: '16px',
            fontWeight: 'bold',
            borderBottomLeftRadius: '10px',
            borderBottomRightRadius: '10px',
        },
        popover: {
            flat: {
                width: popoverWidth,
                maxWidth: 'none',
                body: {
                    backgroundColor: '#2f3349',
                    width: popoverWidth,
                },
                header: {
                    backgroundColor: flatHeaderBgColor,
                    color: 'white',
                },
            },
            buyGet: {
                width: popoverWidth,
                maxWidth: 'none',
                body: {
                    backgroundColor: '#2f3349',
                    width: popoverWidth,
                },
                header: {
                    backgroundColor: buyGetHeaderBgColor,
                    color: 'white',
                },
            },
        },
        loadingContainer: {
            height: '100px',
            maxHeight: cardHeight,
            padding: '10px',
            width: popoverWidth,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
    };

    // Generic ProductList component
    const ProductList = ({ products }) => (
        <ListGroup style={styles.productList} className="custom-popover-scroll-bar">
            {products.map((product, idx) => (
                <ListGroupItem key={idx} style={styles.productItem} className="custom-popover-scroll-bar__list-item">
                    {product.name}
                    <span style={{ float: 'right' }}>{product.entered_no_of_cartons}</span>
                </ListGroupItem>
            ))}
        </ListGroup>
    );

    // Generic OfferCard component
    const OfferCard = ({ title, total_cartons, nextSlot = null, products }) => (
        <Card style={styles.cardStyle}>
            <CardHeader style={styles.cardTitle}>
                <p style={{ margin: 0, padding: 0, fontWeight: 'bold', fontSize: '14px' }}>
                    Offer Details: <br />
                    {title}
                </p>
                <div
                    style={{
                        width: '100%',
                        margin: '4px 0',
                        height: '2px',
                        backgroundColor: 'white',
                    }}
                />
                <p style={{ margin: 0, padding: 0, fontWeight: 'bold', fontSize: '14px' }}>
                    Total Cartons Added in Cart: {total_cartons}
                </p>
                {nextSlot ? (
                    <ul style={{ marginTop: '6px', paddingLeft: '20px' }}>
                        <li
                            style={{
                                margin: 0,
                                padding: '2px 5px',
                                fontWeight: 'bold',
                                fontSize: '14px',
                                color: 'white',
                            }}
                        >
                            NOTE: {`${nextSlot}`}
                        </li>
                    </ul>
                ) : null}
            </CardHeader>
            <CardBody style={styles.cardBodyStyle}>
                <ProductList products={products} />
            </CardBody>
        </Card>
    );

    // Generic render function for offer details
    const renderOfferDetails = (products, groupingFunction, titleFormatter) => {
        if (_.isEmpty(products)) {
            return (
                <p className="text-center" style={styles.noProductTitle}>
                    No discounts available for this category
                </p>
            );
        }

        const grouped = groupingFunction(products);

        return (
            <div style={styles.cardContainer} className="custom-popover-scroll-bar">
                {grouped.map((group, index) => (
                    <OfferCard
                        key={index}
                        title={titleFormatter(group)}
                        total_cartons={group.total_cartons}
                        nextSlot={group.nextSlot}
                        get={group.get}
                        products={group.products}
                    />
                ))}
            </div>
        );
    };

    // Specific grouping functions
    const groupFlatOffers = (products) => {
        const grouped = _.groupBy(products, (p) => `${p.flat_discount_percentage}${p.flat_discount_min_cartons_qty}`);
        let nextSlot = null;
        return Object.entries(grouped).map(([key, products]) => {
            let totalCartons = _.sumBy(products, 'no_of_carton');
            if (products[0].flat_discount_min_cartons_qty > totalCartons) {
                let toAvailNextSlot = products[0].flat_discount_min_cartons_qty - totalCartons;
                nextSlot = `Unlock ${products[0].flat_discount_percentage}% off - Just ${toAvailNextSlot} more cartons.`;
            }
            return {
                percentage: products[0].flat_discount_percentage,
                minQty: products[0].flat_discount_min_cartons_qty,
                total_cartons: totalCartons,
                nextSlot: nextSlot,
                products: products.map((p) => {
                    return {
                        name: p.product,
                        entered_no_of_cartons: p.no_of_carton,
                    };
                }),
            };
        });
    };

    const groupBuyGetOffers = (products) => {
        const grouped = _.groupBy(products, (p) => `${p.buy}${p.gets}`);
        return Object.entries(grouped).map(([key, products]) => {
            let totalCartons = _.sumBy(products, 'no_of_carton');
            const totalSets = Math.ceil(totalCartons / (products[0].buy + products[0].gets));
            const nextTotalCartons = totalSets * (products[0].buy + products[0].gets);
            let toAvailNextSlot = nextTotalCartons - totalCartons;
            return {
                buy: products[0].buy,
                get: products[0].gets,
                nextSlot: `Add ${toAvailNextSlot} more carton(s) to get ${products[0].gets} carton(s) free.`,
                total_cartons: totalCartons,
                products: products.map((p) => {
                    return {
                        name: p.product,
                        entered_no_of_cartons: p.no_of_carton,
                    };
                }),
            };
        });
    };

    const groupBuyGetRecurringOffers = (products) => {
        const groupedByOffer = _.groupBy(products, (p) => JSON.stringify(p.buy_get_recurring));
        return Object.entries(groupedByOffer).map(([offer, products]) => {
            const buyGetRecurring = JSON.parse(offer);
            const totalCartons = _.sumBy(products, 'no_of_carton');
            let nextSlot = buyGetRecurringMessage(totalCartons, buyGetRecurring);
            return {
                offer: JSON.parse(offer),
                nextSlot: nextSlot,
                total_cartons: totalCartons,
                products: products.map((p) => {
                    return {
                        name: p.product,
                        entered_no_of_cartons: p.no_of_carton,
                    };
                }),
            };
        });
    };

    const buyGetRecurringMessage = (cartQuantity, withoutSortedSlots) => {
        const slots = withoutSortedSlots.sort((a, b) => a.buy - b.buy);
        const threSoldSlots = slots.map((x) => ({
            ...x,
            thresold: x.buy + x.gets,
        }));
        const findSlot = threSoldSlots.find((x) => cartQuantity < x.thresold);
        if (!findSlot) {
            const results = revealSlotForNextOfferForBuyGetRecurring(cartQuantity, threSoldSlots);
            return `Add ${results.slot.thresold - results.minusCartons} more carton(s) to get ${
                results.slot.gets
            } carton(s) free`;
        } else {
            return `Add ${findSlot.thresold - cartQuantity} more carton(s) to get ${findSlot.gets} carton(s) free`;
        }
    };

    const revealSlotForNextOfferForBuyGetRecurring = (cartQuantity, threSoldSlots) => {
        const lastElementThresold = threSoldSlots[threSoldSlots.length - 1].thresold;
        let newEnteredCartons = cartQuantity - lastElementThresold;
        const slot = threSoldSlots.find((x) => newEnteredCartons < x.thresold);
        if (!slot) {
            return revealSlotForNextOfferForBuyGetRecurring(newEnteredCartons, threSoldSlots);
        } else {
            return {
                slot: slot,
                minusCartons: newEnteredCartons,
            };
        }
    };

    // Content renderer with loading state
    const ContentRenderer = ({ children }) =>
        offerLoading ? (
            <div style={styles.loadingContainer}>
                <Spinner color="primary" />
            </div>
        ) : (
            children
        );

    let offers = {
        id: null,
        target: null,
        title: null,
        content: null,
        style: null,
    };

    if (!_.isEmpty(flatOfferDiscountInfo) && isFlatOfferProductInCart) {
        offers = {
            id: 'flat-offer',
            target: 'flat-offer-popover',
            title: 'Flat Discount Offers',
            content: renderOfferDetails(flatOfferDiscountInfo, groupFlatOffers, (group) => {
                return `Get ${group.percentage}% Off! Add any of the listed products to your cart and get ${group.percentage}% off when the total number of cartons reaches ${group.minQty} or more.`;
            }),
            style: styles.popover.flat,
        };
    }
    if (!_.isEmpty(buyGetOfferDiscountInfo) && isBuyGetOfferProductInCart) {
        offers = {
            id: 'buy-get-offer',
            target: 'buy-get-offer-popover',
            title: 'Buy & Get Offers',
            content: renderOfferDetails(
                buyGetOfferDiscountInfo,
                groupBuyGetOffers,
                (group) => `Buy ${group.buy} Get ${group.get} Free`,
            ),
            style: styles.popover.buyGet,
        };
    }
    if (!_.isEmpty(buyGetRecurringDiscountInfo) && isBuyGetRecurringProductInCart) {
        offers = {
            id: 'buy-get-recurring-offer',
            target: 'buy-get-recurring-offer-popover',
            title: 'Buy & Get Recurring Offers',
            content: renderOfferDetails(buyGetRecurringDiscountInfo, groupBuyGetRecurringOffers, (group) =>
                group.offer.map((o, idx) => (
                    <React.Fragment key={idx}>
                        Buy {o.buy} Get {o.gets} Free
                        {idx < group.offer.length - 1 && ', '}
                    </React.Fragment>
                )),
            ),
            style: styles.popover.buyGet,
        };
    }

    const { id, target, title, content, style } = offers;
    if (!id || !target || !title || !content || !style) return null;
    
    return (
        <div className="d-block" data-is-open={popoverOpen[id]}>
            <Modal
                // key={id}
                // hideArrow
                // target={target}
                // isOpen={popoverOpen[id]}
                // toggle={() => {
                //     setPopoverOpen(id);
                // }}
                // placement="bottom"
                // trigger="focus"
                className="custom-popover-offer-info-box"
                isOpen={popoverOpen[id]}
                toggle={() => setPopoverOpen(id)}
                centered
            >
                <ModalHeader className="custom-popover-offer-info-box-header">{title}</ModalHeader>
                <ModalBody className="p-0" style={style.body}>
                    <ContentRenderer>{content}</ContentRenderer>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default OfferInfo;
